import React from "react";
import { DropzoneAreaBase, FileObject } from "material-ui-dropzone";
import { Typography } from "@material-ui/core";

type Props = {
    file: FileObject | null;
    onAdd: (file: FileObject) => any;
}

const Screen1: React.FC<Props> = ({file, onAdd}) => {
    return (
        <div style={{ paddingTop: 112, textAlign: "center" }}>
            <Typography variant="h4">Upload document</Typography>
            <p style={{padding: '16px 0 32px'}}>You can upload Word Docs and PDF files</p>
            <DropzoneAreaBase
                filesLimit={1}
                fileObjects={!!file ? [file] : []}
                onAdd={(newFileObjs) => {
                    console.log("onAdd", newFileObjs[0]);
                    onAdd(newFileObjs[0]);
                }}
                maxFileSize={10000000}
            />
        </div>
    );
};

export default Screen1;
